import { useParams } from "react-router-dom";
import PostEdit from "../components/news/posts/PostEdit";
import Title from '../components/Title';
import useCache from '../hooks/use-cache';
import useLocalization from '../hooks/use-localization';
import { useGetPostQuery } from '../store';

export default function PostEditPage() {

    const localization = useLocalization().newsManagement || {};
    //TODO: to move to postAPI
    const getNewModel = function () {
        return {
            id: crypto.randomUUID(),

            title: '',
            author: 'Kazka',

            categories: [],
            creationDate: new Date().toJSON().substring(0, 10),

            topContent: '',
            topImage: '',

            content: ''
        };
    };

    const { id } = useParams();
    const cacheKey = `post-${id}`;
    const { data } = useCache(cacheKey, useGetPostQuery, id);

    const model = data?.id ? data : getNewModel();

    return (
        <>
            <Title value={localization.title}></Title>
            <PostEdit post={model} labels={localization}></PostEdit>
        </>
    );
}